import React from 'react';
import UniversalAuthPage from '../../../components/Auth/UniversalAuthPage';
import { getEmailValidationError } from '../../../utils/emailValidation';

const AirlinerRegisterPage = () => {
  const handleRegister = async (formData) => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // Simulate registration success
    alert('Registration successful! Please check your email for verification.');
    // Navigation is handled by UniversalAuthPage
  };

  const additionalFields = [
    {
      label: 'First Name',
      name: 'firstName',
      placeholder: 'First name',
      required: true,
      className: 'col-span-1'
    },
    {
      label: 'Last Name', 
      name: 'lastName',
      placeholder: 'Last name',
      required: true,
      className: 'col-span-1'
    }
  ];

  const customValidation = (formData, setErrors) => {
    const newErrors = {};

    if (!formData.firstName?.trim()) {
      newErrors.firstName = 'First name is required';
    }

    if (!formData.lastName?.trim()) {
      newErrors.lastName = 'Last name is required';
    }

    const emailValidationMessage = getEmailValidationError(formData.email);
    if (emailValidationMessage) {
      newErrors.email = emailValidationMessage;
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 11) {
      newErrors.password = 'Password must be at least 11 characters long';
    }

    if (!formData.passwordConfirmation) {
      newErrors.passwordConfirmation = 'Please confirm your password';
    } else if (formData.password !== formData.passwordConfirmation) {
      newErrors.passwordConfirmation = 'Passwords do not match';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <UniversalAuthPage
      type="register"
      appType="airliner"
      title="Airliner Registration"
      subtitle="Create your airliner management account"
      onSubmit={handleRegister}
      additionalFields={additionalFields}
      showPasswordGenerator={true}
      customValidation={customValidation}
      redirectPaths={{
        success: '/airliner/auth/login'
      }}
    />
  );
};

export default AirlinerRegisterPage;